import { useState } from 'react';
import './App.css';
import { ASSET_BASE } from './components/demoAssets';
import ImageUploader from './components/ImageUploader';
import ProcessingView from './components/ProcessingView';
import ResultPage from './components/ResultPage';

function App() {
  const [step, setStep] = useState('upload');

  const resetFlow = () => {
    setStep('upload');
  };

  return (
    <div className="app-shell">
      <header className="topbar">
        <img src={`${ASSET_BASE}/nextastra-logo.png`} alt="Nextastra" />
        <span>2D to 3D Studio</span>
      </header>

      {step === 'upload' && (
        <>
          <ImageUploader
            onGenerate={() => setStep('processing')}
          />
        </>
      )}

      {step === 'processing' && <ProcessingView onComplete={() => setStep('result')} />}
      {step === 'result' && <ResultPage onReset={resetFlow} />}
    </div>
  );
}

// Development note: this prototype maps the predefined sample image to the
// bundled GLB model. Production should replace this with a real generation API.

export default App;
